var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',[_vm._v("Daftar FPP")])]},proxy:true}])},[_c('FormFilterPengajuan'),_c('TablePengajuan')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }